import commonData from '@/commondata.js'
import request from '@/utils/request'
import { Dialog } from 'vant'
import router from '@/router'

export function checkActivity(activity, isAlert) {
  if (!activity) {
    return false
  }
  if (activity.isStart) {
    return true
  }
  if (activity.dateBegin) {
    if (new Date() < new Date(activity.dateBegin)) {
      Dialog.confirm({
        title: '活动尚未开始',
        message: '该活动将于' + activity.dateBegin + '开启!\n请稍后访问',
        confirmButtonText: '返回首页',
        cancelButtonText: '留下来'
      })
        .then(() => {
          router.push('/store/index')
        })
      return false
    }
  }
  if (activity.dateEnd) {
    if (new Date() > new Date(activity.dateEnd)) {
      Dialog.confirm({
        title: '活动已经结束',
        message: '该活动已经于' + activity.dateEnd + '结束!',
        confirmButtonText: '返回首页',
        cancelButtonText: '留下来'
      })
        .then(() => {
          router.push('/store/index')
        })
      return false
    }
  }
}

export function getSystemMoneyExchangeList(callback) {
  if (commonData.moneyExchangeList) {
    if (callback) {
      callback(commonData.moneyExchangeList)
    }
  } else {
    request({
      url: '/Pro/getMoneyExchangeList',
      method: 'post',
      params: { isSystem: true }
    }).then(response => {
      commonData.moneyExchangeList = []
      if (!response.success) {
        return
      }
      commonData.moneyExchangeList = response.data
      if (callback) {
        callback(commonData.moneyExchangeList)
      }
    })
  }
}

export function getDiveCommentConfigList(callback) {
  if (commonData.diveCommentConfigList) {
    if (callback) {
      callback(commonData.diveCommentConfigList)
    }
  } else {
    request({
      url: '/DiveData/getCommentConfig',
      method: 'post'
    }).then(response => {
      commonData.diveCommentConfigList = []
      if (!response.success) {
        return
      }
      commonData.diveCommentConfigList = response.data
      commonData.diveCommentConfigList.forEach(item => {
        if (item.tagNices) {
          item.tagNices = item.tagNices.split(',')
        } else {
          item.tagNices = []
        }
        if (item.tagBadlys) {
          item.tagBadlys = item.tagBadlys.split(',')
        } else {
          item.tagBadlys = []
        }
      })
      if (callback) {
        callback(commonData.diveCommentConfigList)
      }
    })
  }
}

export function getDiveCenterList(callback) {
  if (commonData.diveCenterList) {
    if (callback) {
      callback(commonData.diveCenterList)
    }
  } else {
    request({
      url: '/DiveTrip/getDiveCenterList',
      method: 'post'
    }).then(response => {
      commonData.diveCenterList = []
      if (!response.success) {
        return
      }
      commonData.diveCenterList = response.data

      if (callback) {
        callback(commonData.diveCenterList)
      }
    })
  }
}
export function getDiveCourseList(callback) {
  if (commonData.diveCourseList) {
    if (callback) {
      callback(commonData.diveCourseList)
    }
  } else {
    request({
      url: '/DiveTrip/getDiveCourseSelectList',
      method: 'post'
    }).then(response => {
      commonData.diveCourseList = []
      if (!response.success) {
        return
      }
      commonData.diveCourseList = response.data
      if (callback) {
        callback(commonData.diveCourseList)
      }
    })
  }
}
export function checkInDropDownList(list, key) {
  if (!key) {
    return undefined
  }
  console.log(list)
  console.log('b', list.filter(m => m.key === key).length)
  if (list.filter(m => m.key === key).length <= 0) {
    return undefined
  }
  return key
}

export function getAidaConfig(callback) {
  if (commonData.aidaConfigList) {
    if (callback) {
      callback(commonData.aidaConfigList)
    }
  } else {
    request({
      url: '/Pro/GetAidaConfig',
      method: 'post'
    }).then(response => {
      commonData.aidaConfigList = undefined
      if (!response.success) {
        return
      }
      commonData.aidaConfigList = response.data
      if (callback) {
        callback(commonData.aidaConfigList)
      }
    })
  }
}
